import { Form, Input } from "antd";

import { AppButton } from "components/button/AppButton";
import avatar from "assets/images/default.webp";
import {
  useGetTalentProfile,
} from "features/settings/hooks/useGetTalentProfile";
import { useState } from "react";
import { useUpdateTalentProfile } from "features/settings/hooks/useUpdateTalentProfile";
import ProfileSidebar from "./TalentProfileSidebar";
import { Projects } from "./Projects";

const DEFAULT_COVER = "/assets/cover_image.png";

export const TalentProjects = () => {
  const { data, isLoading: isGetTPLoading } = useGetTalentProfile();
  const [form] = Form.useForm();
  const { mutate, isLoading: isUpdateTPLoading } = useUpdateTalentProfile();
  const [resizedBlob, setResizedBlob] = useState<Blob | null>(null);
  const [coverPhotoBlob, setCoverPhotoBlob] = useState<Blob | null>(null);
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const [active, setActive] = useState("Projects");

  return (
    <>
      <Form form={form} disabled={isGetTPLoading}>
        <div className="flex justify-between mb-4">
          <div>
            <h4 className="font-semibold text-lg text-primary">
              Personal info
            </h4>
            <h3 className="text-sm">Update your details here.</h3>
          </div>
        </div>
        <hr />
        <div className="grid grid-cols-1 md:grid-cols-5 my-3 md:my-5 gap-3">
          <Form.Item noStyle name="image">
            <Input type="hidden" />
          </Form.Item>

          <div className="relative col-span-5">
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              id="fileInput"
            />
            <img
              src={
                coverPhotoBlob
                  ? URL.createObjectURL(coverPhotoBlob)
                  : data?.data.user.cover_photo || DEFAULT_COVER
              }
              alt="cover"
              className="w-full h-full object-cover"
            />

            <div className="absolute -bottom-6 left-4">
              <div className="relative w-fit">

                <img
                  src={
                    resizedBlob
                      ? URL.createObjectURL(resizedBlob)
                      : data?.data.dp ?? avatar
                  }
                  alt="avatar"
                  className="h-20 w-20 rounded-full border-2 border-white shadow-lg"
                />

                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="cover_photo"
                />
              </div>
            </div>

            <h3 className="font-medium mt-10"></h3>
            <h3 className="text-xs"></h3>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
          <ProfileSidebar active={active} onSelect={setActive} />

          <div className="md:col-span-5 p-4 rounded shadow-lg w-full">
            <Projects isLoading={isGetTPLoading} data={data ? data?.data.projects : []} />
            <br />
            <hr />
          </div></div>
      </Form>
    </>
  );
};
